var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.order && _vm.order.status == 0)?_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.handleRenotify()}}},[_vm._v("Renotify POS")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }